import { match } from "ts-pattern";
import type { PanelVisuProps } from "..";

/**
 * @returns `length` & `width` of the panel no matter what shape it is
 */
export function getPanelSize(workpiece: PanelVisuProps["workpiece"]) {
	return match(workpiece)
		.with({ shape: "plate_rectangle_square" }, (s) => ({
			length: s.shape_dimensions.width,
			width: s.shape_dimensions.width,
		}))
		.with({ shape: "plate_rectangle_custom" }, (s) => ({
			length: s.shape_dimensions.length,
			width: s.shape_dimensions.width,
		}))
		.with({ shape: "plate_rectangle_rounded_corners" }, (s) => ({
			length: s.shape_dimensions.length,
			width: s.shape_dimensions.width,
		}))
		.with({ shape: "plate_rectangle_bevelled_corners" }, (s) => ({
			length: s.shape_dimensions.length,
			width: s.shape_dimensions.width,
		}))
		.with({ shape: "plate_rectangle_angled_length" }, (s) => ({
			length: s.shape_dimensions.length,
			width: Math.max(s.shape_dimensions.width_1, s.shape_dimensions.width_2),
		}))
		.with({ shape: "plate_rectangle_angled_width" }, (s) => ({
			length: Math.max(s.shape_dimensions.length_1, s.shape_dimensions.length_2),
			width: s.shape_dimensions.width,
		}))
		.with({ shape: "plate_triangle_regular" }, (s) => ({
			length: s.shape_dimensions.length_1 + s.shape_dimensions.length_2,
			width: s.shape_dimensions.width,
		}))
		.with({ shape: "plate_triangle_symmetrical" }, (s) => ({
			length: s.shape_dimensions.length,
			width: s.shape_dimensions.width,
		}))
		.with({ shape: "plate_triangle_rectangular" }, (s) => ({
			length: s.shape_dimensions.length,
			width: s.shape_dimensions.width,
		}))
		.with({ shape: "plate_circle_complete" }, (s) => ({
			length: s.shape_dimensions.width,
			width: s.shape_dimensions.width,
		}))
		.with({ shape: "plate_circle_half" }, (s) => ({
			length: s.shape_dimensions.width,
			width: s.shape_dimensions.width / 2,
		}))
		.with({ shape: "plate_circle_quarter" }, (s) => ({
			length: s.shape_dimensions.width,
			width: s.shape_dimensions.width,
		}))
		.with({ shape: "plate_oval_regular" }, (s) => ({
			length: s.shape_dimensions.length,
			width: s.shape_dimensions.width,
		}))
		.with({ shape: "plate_oval_flat" }, (s) => ({
			length: s.shape_dimensions.length,
			width: s.shape_dimensions.width,
		}))
		.with({ shape: "plate_trapezium" }, (s) => ({
			length: Math.max(s.shape_dimensions.length_1, s.shape_dimensions.length_2),
			width: s.shape_dimensions.width,
		}))
		.with({ shape: "plate_parallelogram" }, (s) => ({
			length: s.shape_dimensions.length_1 + s.shape_dimensions.length_2,
			width: s.shape_dimensions.width,
		}))
		.with({ shape: "plate_arrow" }, (s) => ({
			length: s.shape_dimensions.length_1 + s.shape_dimensions.length_2,
			width: Math.max(s.shape_dimensions.width_1, s.shape_dimensions.width_2),
		}))
		.with({ shape: "plate_kite" }, (s) => ({
			length: s.shape_dimensions.length_1 + s.shape_dimensions.length_2,
			width: s.shape_dimensions.width,
		}))
		.otherwise(() => ({ length: 0, width: 0 }));
}
